import { useContext } from 'react'
import { ModalComponents } from '../../../core/Modal'
import { LoadingStatus } from '../../activitybar/sample-packs/SamplePackDropdown'
import Progress from '../Progress'
import { ContactLink } from './components/ContactLink'
import { ModalAlert } from './components/ModalAlert'
import { ConfirmationPage } from './ConfirmationPage'
import { ConfirmSoundAttributionPage } from './ConfirmSoundAttributionPage'
import { Page } from './hooks/useRegisterSongModal'
import { InstructionsPage } from './InstructionsPage'
import { Navigation } from './Navigation'
import { PublishPage } from './PublishPage'
import { RegisterModalContext } from './RegisterSongModal'
import { UploadProjectPage } from './UploadProjectPage'
import { UploadWavPage } from './UploadWavPage'
export const RegisterSongModalContent = () => {
  const { state } = useContext(RegisterModalContext)

  if (state.mintingStatus === LoadingStatus.LOADING)
    return (
      <>
        <ModalComponents.Title>Minting in progress</ModalComponents.Title>
        <ModalComponents.Subtitle>Please wait...</ModalComponents.Subtitle>
        <Progress infinite />
      </>
    )

  if (state.mintingStatus === LoadingStatus.ERROR) {
    return (
      <ModalAlert
        status="error"
        title="An error occurred minting your track"
        description={
          <>
            Need help? <ContactLink />
          </>
        }
      />
    )
  }

  return (
    <>
      {state.page === Page.INSTRUCTIONS && <InstructionsPage />}
      {state.page === Page.UPLOAD_WAV && <UploadWavPage />}
      {state.page === Page.UPLOAD_PROJECT && <UploadProjectPage />}
      {state.page === Page.ATTRIBUTIONS && <ConfirmSoundAttributionPage />}
      {state.page === Page.PUBLISH && <PublishPage />}
      {state.page === Page.CONFIRMATION && <ConfirmationPage />}
      <Navigation />
    </>
  )
}
